import { type KeyCode, useKeyPress } from '@xyflow/react'
import { useState, useEffect } from 'react'

function useShortcut(keyCode: KeyCode, callback: Function): void {
  const [didRun, setDidRun] = useState(false)
  const shouldRun = useKeyPress(keyCode, {
    actInsideInputWithModifier: false,
  })

  useEffect(() => {
    if (shouldRun && !didRun) {
      callback()
      setDidRun(true)
    } else {
      setDidRun(shouldRun)
    }
  }, [shouldRun, didRun, callback])
}

export default useShortcut
